import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "redux/actions/Index";
import DeliveryDatePage from "components/pages/deliveryDate/DeliveryDatePage";
import { IDeliveryDateCreationState } from "interfaces/Index";

export const mapStateToProps = (state: any, props: any): any => {
  const { zone } = state;
  return {
    isLoading: state.deliveryDate.isLoading,
    isError: state.deliveryDate.isError,
    error: state.deliveryDate.error,
    isEdit: state.deliveryDate.isEdit,
    citiesList: zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    isWarehouseCategoriesFetched: state.deliveryDate.isWarehouseCategoriesFetched,
    warehouseCategories: state.deliveryDate.warehouseCategories,
    isFetchWarehouseDeliveryDateConfig: state.deliveryDate.isFetchWarehouseDeliveryDateConfig,
    warehouseDeliveryDateConfig: state.deliveryDate.warehouseDeliveryDateConfig, 
    isWarehouseConfigAdded: state.deliveryDate.isWarehouseConfigAdded,
    // isWarehouseConfigUpdated: state.deliveryDate.isWarehouseDeliveryConfigAdded,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () =>
      dispatch(actions.fetchCities()),
    getWarehouseCategories: (id: string) =>
      dispatch(actions.fetchByCityWareHouseListDeliveryDateAction(id)),
    fetchWarehouseDeliveryDateConfig: (id: string) => 
      dispatch(actions.fetchWarehouseDeliveryDateConfigAction(id)),
    createUpdateWarehouseDeliveryDateConfig: (payload: IDeliveryDateCreationState) =>
      dispatch(actions.createUpdateWarehouseDeliveryDateConfigAction(payload)),
  };
};

const DeliveryDateContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveryDatePage);
export default DeliveryDateContainer;
